<template>
  <div class="create">
    <div class="header-timeline">
      <a-steps :current="0">
        <a-step title="填写职位信息" />
        <a-step title="选择职位服务" />
        <a-step title="填写推广信息" />
        <a-step title="发布职位" />
      </a-steps>
    </div>
    <div class="content">
      <a-form
        :form="form"
        :label-col="{ span: 2 }"
        :wrapper-col="{ span: 8 }"
        @submit="handleSubmit"
      >
        <DividerBar text="企业信息"></DividerBar>
        <a-form-item label="公司名称">
          <!-- <a-auto-complete
            class="company"
            placeholder="输入公司名称自动搜索"
            v-decorator="[
              'company_id',
              { rules: [{ required: true, message: '仅可填写已签约的客户名称' }] }
            ]"
            :dataSource="dataCompanyNameList"
            @search="onSearchCompany"
            @select="selectComId"
          ></a-auto-complete> -->
          <a-select
            show-search
            placeholder="输入公司名称自动搜索"
            v-decorator="[
              'company_id',
              {
                rules: [
                  { required: true, message: '仅可填写已签约的客户名称' },
                ],
              },
            ]"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @search="onSearchCompany"
            @change="selectComId"
          >
            <a-select-option
              v-for="item in dataCompanyNameList"
              :key="item.value"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <DividerBar text="职位信息"></DividerBar>
        <a-form-item label="职位属性" :wrapper-col="{ span: 12 }">
          <a-radio-group
            v-decorator="[
              'job_attribute',
              {
                rules: [{ required: true, message: '请选择职位属性' }],
                initialValue: job_attribute,
              },
            ]"
            @change="changeJobAttribute"
          >
            <div style="margin-top: 10px">
              <a-radio value="2">全职雇佣</a-radio>
              <div class="radio-tip">
                雇主需与个人签订劳动合同，员工享受国家规定的职工保险待遇等
              </div>
            </div>
            <div style="margin-top: 10px">
              <a-radio value="3">灵活用工</a-radio>
              <div class="radio-tip">
                无需与签订劳动合同；个人提供服务，雇主支付费用，任务结束合作关系终止
              </div>
            </div>
            <!-- <div style="margin-top: 10px">
              <a-radio value="4">赚钱任务</a-radio>
            </div> -->
          </a-radio-group>
        </a-form-item>
        <!-- v-if="job_attribute !== '4'" -->
        <a-form-item label="职位类型">
          <a-cascader
            changeOnSelect
            :options="functionId"
            placeholder="请选择职能类型"
            @click="initFuncData"
            :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
            v-decorator="[
              `category_id`,
              { rules: [{ required: true, message: '请选择职能类型' }] },
            ]"
          />
        </a-form-item>
        <a-form-item :label="job_attribute == '4' ? '任务名称' : '职位名称'">
          <a-input
            placeholder="请输入职位名称"
            v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入职位名称！' }] },
            ]"
          />
        </a-form-item>

        <a-form-item label="任务介绍" v-if="job_attribute == '4'">
          <a-textarea
            placeholder="请输入工作内容和工作要求"
            :rows="5"
            v-decorator="[
              'description',
              {
                rules: [{ required: true, message: '请输入任务介绍！' }],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="工作内容" v-else>
          <a-textarea
            placeholder="请输入工作内容和工作要求"
            :rows="5"
            v-decorator="[
              'requirements',
              {
                rules: [
                  { required: true, message: '请输入工作内容和工作要求！' },
                ],
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="薪资待遇" v-if="job_attribute == '4'">
          <a-textarea
            placeholder="请输入薪资待遇描述"
            :rows="5"
            v-decorator="[
              'task_salary',
              { rules: [{ required: true, message: '请输入岗位要求！' }] },
            ]"
          />
        </a-form-item>
        <a-form-item label="岗位要求" v-else>
          <a-textarea
            placeholder="请输入岗位要求"
            :rows="5"
            v-decorator="[
              'description',
              { rules: [{ required: true, message: '请输入岗位要求！' }] },
            ]"
          />
        </a-form-item>

        <template v-if="job_attribute === '4'">
          <a-form-item
            label="雇佣状态"
            :label-col="{ span: 2 }"
            :wrapper-col="{ span: 5 }"
          >
            <a-radio-group
              :rows="5"
              :options="taskWorkEmployTypeData"
              v-decorator="[
                `task_work_employ_type`,
                {
                  rules: [{ required: true, message: '请选择兼职雇佣状态！' }],
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            label="时间类型"
            :label-col="{ span: 2 }"
            :wrapper-col="{ span: 5 }"
          >
            <a-radio-group
              :options="taskWorkTimeTypeData"
              :rows="5"
              v-decorator="[
                `task_work_time_type`,
                {
                  rules: [
                    { required: true, message: '请选择兼工作时间类型！' },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item
            label="任务时长"
            :label-col="{ span: 2 }"
            :wrapper-col="{ span: 5 }"
          >
            <a-input
              style="display: inline-block; width: 150px"
              placeholder="请输入时长"
              v-decorator="[
                'task_work_time',
                { rules: [{ required: true, message: '请输入时长！' }] },
              ]"
            />
          </a-form-item>
          <a-form-item
            label="初始人数"
            :label-col="{ span: 2 }"
            :wrapper-col="{ span: 7 }"
          >
            <a-input
              style="display: inline-block; width: 150px"
              placeholder="初始报名人数"
              v-decorator="[
                'task_fake_user_count',
                {
                  rules: [{ required: true, message: '请输入初始报名人数！' }],
                },
              ]"
            />
          </a-form-item>

          <DividerBar text="步骤引导"></DividerBar>
          <a-form-item
            v-for="(k, index) in keysList"
            :key="k"
            :label="`第${index + 1}步`"
            :required="false"
          >
            <a-textarea
              placeholder="请输入完成任务的步骤说明"
              :rows="5"
              v-decorator="[
                `task_step_content[${k}]`,
                {
                  validateTrigger: ['change', 'blur'],
                  rules: [
                    {
                      required: true,
                      whitespace: true,
                      message: '请输入步骤流程',
                    },
                  ],
                },
              ]"
            />
            <a-icon
              v-if="keysList.length > 1"
              class="dynamic-delete-button"
              type="minus-circle-o"
              @click="() => remove(k)"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayoutWithOutLabel">
            <a-button type="dashed" style="width: 60%" @click="addRow">
              <a-icon type="plus" /> 添加步骤流程
            </a-button>
          </a-form-item>
        </template>

        <a-form-item
          label="工作地点"
          :wrapper-col="{ span: 14 }"
          v-if="job_attribute === '2'"
        >
          <a-cascader
            changeOnSelect
            :options="cityOptions"
            v-decorator="[
              'city',
              { rules: [{ required: true, message: '请选择工作地点！' }] },
            ]"
            :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
            placeholder="请选择城市"
            style="width: 32%"
            @click="getOptions"
            @change="handleSelectCity"
          >
          </a-cascader>
          <a-auto-complete
            placeholder="输入工作地点系统自动定位"
            style="width: 50%; margin-left: 5px"
            v-decorator="['location']"
            :dataSource="addressData"
            @search="onSearchAddress"
            @select="selectLocation"
            optionLabelProp="text"
          >
            <template slot="dataSource">
              <a-select-option
                v-for="item in addressData"
                :key="item.name"
                :text="item.name"
                :location="item.location"
              >
                {{ item.name }}
              </a-select-option>
            </template>
          </a-auto-complete>
        </a-form-item>
        <!-- 兼职 -->
        <!-- <a-form-item label="招收人数" v-if="job_attribute==='3'">
          <a-input
            placeholder="请输入招收人数，1-99999"
            v-decorator="[
              'quantity',
              { rules: [{ required: true, message: '请输入招收人数' }] }
            ]"
          />
        </a-form-item> -->
        <DividerBar
          :text="job_attribute === '2' ? '薪资福利' : '薪资报酬'"
        ></DividerBar>
        <template v-if="job_attribute == '2'">
          <a-form-item label="基本薪资" :wrapper-col="{ span: 20 }">
            <a-input
              style="display: inline-block; width: 150px"
              placeholder="请输入金额"
              v-decorator="[
                'hunter_salary_min',
                { rules: [{ required: job_attribute == '2' ? true : false, message: '请输入金额！' }] },
              ]"
            />-<a-input
              style="display: inline-block; width: 150px"
              placeholder="请输入金额"
              v-decorator="[
                'hunter_salary_max',
                { rules: [{ required: job_attribute == '2' ? true : false, message: '请输入金额！' }] },
              ]"
            />
            万/年 *
            <a-select
              v-decorator="[
                'salary_type',
                { rules: [{ required: job_attribute == '2' ? true : false, message: '请选择薪资制度！' }] },
              ]"
              style="width: 200px; margin-left: 5px"
              placeholder="请选择薪资制度"
            >
              <a-select-option value="1">12薪</a-select-option>
              <a-select-option value="2">13薪</a-select-option>
              <a-select-option value="3">14薪</a-select-option>
              <a-select-option value="4">15薪</a-select-option>
              <a-select-option value="5">16薪</a-select-option>
              <a-select-option value="6">16薪+</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="公司福利">
            <a-select
              mode="multiple"
              placeholder="选择公司福利"
              v-decorator="['selling_point_tags']"
            >
              <template v-for="(item, g) in companyWelfareTree">
                <a-select-opt-group :label="item.label" :key="g">
                  <a-select-option
                    :value="x.value"
                    v-for="(x, i) in item.options"
                    :key="i"
                  >
                    {{ x.label }}
                  </a-select-option>
                </a-select-opt-group>
              </template>
            </a-select>
          </a-form-item>
        </template>
        <template v-else>
          <a-form-item label="基本薪资">
            <a-input
              style="width: 70%"
              placeholder="请输入金额"
              v-decorator="[
                'flexible_job.basic_salary',
                { rules: [{ required: true, message: '请输入金额！' }] },
              ]"
              addonAfter="元"
            />
            <a-select
              placeholder="请选择"
              v-decorator="[
                'flexible_job.basic_salary_period',
                { rules: [{ required: true, message: '请选择薪资制度！' }] },
              ]"
              style="width: 28%; margin-left: 5px"
            >
              <a-select-option value="1">小时</a-select-option>
              <a-select-option value="2">天</a-select-option>
              <a-select-option value="3">周</a-select-option>
              <a-select-option value="4">月</a-select-option>
              <a-select-option value="5">次</a-select-option>
              <a-select-option value="6">其他</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="结算方式" :wrapper-col="{ span: 12 }">
            <a-radio-group
              :options="settlementData"
              v-decorator="[
                `flexible_job.settlement_method`,
                { rules: [{ required: true, message: '请选择结算方式！' }] },
              ]"
            />
          </a-form-item>
          <DividerBar text="提成福利"></DividerBar>
          <a-form-item label="提成类型" :wrapper-col="{ span: 12 }">
            <a-radio-group
              v-decorator="[
                `flexible_job.bonus_type`,
                { rules: [{ required: true, message: '请选择提成类型！' }] },
              ]"
              @change="
                (e) => {
                  bonus_type = e.target.value;
                }
              "
            >
              <a-radio :value="1">无提成</a-radio>
              <a-radio :value="2">业绩提成</a-radio>
              <a-radio :value="3">计件提成</a-radio>
              <a-radio :value="4">自定义</a-radio>
            </a-radio-group>
            <a-input
              v-if="bonus_type == 2 || bonus_type == 3 || bonus_type == 4"
              style="width: 50%"
              :placeholder="
                bonus_type == 2
                  ? '请输入提成比例'
                  : bonus_type == 3
                  ? '请输入金额'
                  : '最多输入30个字'
              "
              v-decorator="[
                'flexible_job.bonus_value',
                { rules: [{ required: true, message: '请输入金额！' }] },
              ]"
              :addonAfter="
                bonus_type == 3 ? '元/件' : bonus_type == 2 ? '%' : ''
              "
            />
          </a-form-item>
          <a-form-item label="其他福利">
            <a-select
              mode="multiple"
              placeholder="选择福利"
              v-decorator="['selling_point_tags']"
            >
              <template v-for="(item, g) in companyWelfareTree">
                <a-select-opt-group :label="item.label" :key="g">
                  <a-select-option
                    :value="x.value"
                    v-for="(x, i) in item.options"
                    :key="i"
                  >
                    {{ x.label }}
                  </a-select-option>
                </a-select-opt-group>
              </template>
            </a-select>
          </a-form-item>

          <DividerBar text="时间地点"></DividerBar>
          <a-form-item label="工作日期" v-if="job_attribute !== '4'">
            <a-radio-group
              v-decorator="[
                'work_date_type',
                { rules: [{ required: true, message: '工作日期' }] },
              ]"
              @change="
                (e) => {
                  work_date_type = e.target.value;
                }
              "
            >
              <a-radio :value="0">无指定日期</a-radio>
              <a-radio :value="1">指定日期</a-radio>
            </a-radio-group>
            <a-select
              v-if="work_date_type == 0"
              v-decorator="[
                'flexible_job.work_date_type',
                { rules: [{ required: true, message: '请选择工作日期' }] },
              ]"
              placeholder="请选择"
            >
              <a-select-option :value="1">周末节假日</a-select-option>
              <a-select-option :value="2">工作日</a-select-option>
              <a-select-option :value="3">根据个人时间</a-select-option>
            </a-select>
            <a-range-picker
              v-if="work_date_type == 1"
              format="YYYY-MM-DD"
              v-decorator="[
                'flexible_job.work_date_value',
                { rules: [{ required: true, message: '请选择工作日期' }] },
              ]"
            />
          </a-form-item>
          <a-form-item
            label="工作时间"
            v-if="job_attribute !== '4'"
            :wrapper-col="{ span: 14 }"
          >
            <a-radio-group
              v-decorator="[
                'work_time_type',
                { rules: [{ required: true, message: '请选择工作时间' }] },
              ]"
              @change="
                (e) => {
                  work_time_type = e.target.value;
                }
              "
            >
              <a-radio :value="0">不限时段</a-radio>
              <a-radio :value="1">指定时段</a-radio>
            </a-radio-group>

            <template v-if="work_time_type == 1">
              <a-time-picker
                format="HH:mm"
                v-decorator="[
                  'flexible_job.work_time_start_at',
                  {
                    rules: [{ required: true, message: '请选择工作时间' }],
                    initialValue: moment('9:00', 'HH:mm'),
                  },
                ]"
              />
              <a-time-picker
                format="HH:mm"
                v-decorator="[
                  'flexible_job.work_time_end_at',
                  {
                    rules: [{ required: true, message: '请选择工作时间' }],
                    initialValue: moment('17:00', 'HH:mm'),
                  },
                ]"
              />
            </template>
          </a-form-item>

          <a-form-item label="到岗要求" :wrapper-col="{ span: 12 }">
            <a-radio-group
              v-decorator="[
                'flexible_job.designated_position_required',
                { rules: [{ required: true, message: '请选择是否到岗' }] },
              ]"
              @change="
                (e) => {
                  postsite_type = e.target.value;
                }
              "
            >
              <a-radio :value="1"
                >是，人选必须到达公司或指定地点开展工作</a-radio
              >
              <a-radio :value="2">否，人选无需到岗，在家即可完成</a-radio>
            </a-radio-group>

            <template v-if="postsite_type == 1">
              <a-cascader
                changeOnSelect
                :options="cityOptions"
                v-decorator="[
                  'city',
                  {
                    rules: [{ required: true, message: '请选择工作地点！' }],
                  },
                ]"
                :fieldNames="{
                  label: 'name',
                  value: 'id',
                  children: 'children',
                }"
                placeholder="请选择城市"
                style="width: 32%"
                @click="getOptions"
                @change="handleSelectCity"
              >
              </a-cascader>
              <a-auto-complete
                placeholder="输入工作地点系统自动定位"
                style="width: 50%; margin-left: 5px"
                v-decorator="['location']"
                :dataSource="addressData"
                @search="onSearchAddress"
                @select="selectLocation"
                optionLabelProp="text"
              >
                <template slot="dataSource">
                  <a-select-option
                    v-for="item in addressData"
                    :key="item.name"
                    :text="item.name"
                    :location="item.location"
                  >
                    {{ item.name }}
                  </a-select-option>
                </template>
              </a-auto-complete>
            </template>
          </a-form-item>

          <a-form-item label="用工时长">
            <a-radio-group
              :options="taskWorkEmployTypeData"
              v-decorator="[
                `task_work_employ_type`,
                { rules: [{ required: true, message: '请选择用工时长！' }] },
              ]"
            />
          </a-form-item>
        </template>
        <DividerBar text="人员要求"></DividerBar>
        <a-form-item
          label="健康证"
          :wrapper-col="{ span: 12 }"
          v-if="job_attribute === '3'"
        >
          <a-radio-group
            v-decorator="[
              'flexible_job.health_requirements',
              {
                rules: [{ required: true, message: '请选择健康证' }],
                initialValue: 0,
              },
            ]"
          >
            <a-radio :value="0">无要求</a-radio>
            <a-radio :value="1">需要</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="性别要求" :wrapper-col="{ span: 12 }">
          <a-radio-group
            v-decorator="[
              'gender_id',
              {
                rules: [{ required: true, message: '请选择性别' }],
                initialValue: 0,
              },
            ]"
          >
            <a-radio :value="0">无要求</a-radio>
            <a-radio :value="1">男</a-radio>
            <a-radio :value="2">女</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="学历要求" :wrapper-col="{ span: 12 }">
          <a-radio-group
            :options="educationData"
            v-decorator="[
              `education_id`,
              {
                rules: [{ required: true, message: '请选择学历！' }],
                initialValue: '0',
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="工作经验" :wrapper-col="{ span: 16 }">
          <a-radio-group
            :options="workExperienceData"
            v-decorator="[
              `experience_id`,
              {
                rules: [{ required: true, message: '请选择工作经验！' }],
                initialValue: '0',
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          label="身高要求"
          :wrapper-col="{ span: 12 }"
          v-if="job_attribute === '3'"
        >
          <a-radio-group
            v-decorator="[
              'flexible_job.height_requirements',
              {
                rules: [{ required: true, message: '请选择身高' }],
                initialValue: 0,
              },
            ]"
            @change="
              (e) => {
                height_requirements = e.target.value;
              }
            "
          >
            <a-radio :value="0">无要求</a-radio>
            <a-radio :value="1">需要</a-radio>
          </a-radio-group>
          <a-input
            v-if="height_requirements"
            style="width: 70%"
            placeholder="请输入身高，150~200cm"
            v-decorator="[
              'flexible_job.height_requirements_value',
              {
                rules: [
                  { required: true, message: '请输入身高！', type: 'number' },
                ],
              },
            ]"
            addonAfter="CM"
          />
        </a-form-item>

        <template v-if="job_attribute === '3'">
          <a-form-item label="招聘人数">
            <a-input-number
              :max="9999"
              v-decorator="[
                'recruitment_count',
                { rules: [{ required: true, message: '请输入招聘人数！' }] },
              ]"
            />
          </a-form-item>

          <DividerBar text="人选是否投递附件简历"></DividerBar>
          <a-form-item :wrapper-col="{ span: 12 }">
            <a-radio-group
              v-decorator="[
                'flexible_job.attached_resume_required',
                {
                  rules: [
                    { required: true, message: '请选择是否需要附件简历' },
                  ],
                },
              ]"
            >
              <a-radio :value="1">是，线上应聘时必须提供附件简历</a-radio>
              <a-radio :value="2">否，无需提供，远程沟通或面试即可</a-radio>
            </a-radio-group>
          </a-form-item>
          <DividerBar text="其他信息"></DividerBar>
          <a-form-item label="联系方式" :wrapper-col="{ span: 12 }">
            <a-radio-group
              :options="contactTypeData"
              v-decorator="[
                'flexible_job.contact_type',
                { rules: [{ required: true, message: '请选择联系方式' }] },
              ]"
              @change="
                (e) => {
                  contact_type = e.target.value;
                }
              "
            />
            <a-input
              v-if="contact_type != 6"
              style="width: 70%"
              placeholder="请输入联系方式"
              v-decorator="[
                'flexible_job.contact_value',
                { rules: [{ required: true, message: '请输入联系方式！' }] },
              ]"
            />
          </a-form-item>
          <a-form-item label="招聘周期" :wrapper-col="{ span: 12 }">
            <a-radio-group
              @change="
                (e) => {
                  recruitment_deadline = e.target.value;
                }
              "
            >
              <a-radio :value="1">长期招聘</a-radio>
              <a-radio :value="2">定期招聘</a-radio>
            </a-radio-group>
            <div v-if="recruitment_deadline == 2">
              职位将在<a-date-picker
                v-decorator="['flexible_job.recruitment_deadline']"
              />日24点自动结束
            </div>
          </a-form-item>
        </template>
        <a-form-item style="text-align: center" :wrapper-col="{ span: 24 }">
          <a-button type="primary" html-type="submit" style="width: 150px">
            下一步
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import DividerBar from "@/components/dividerBar";
import Api from "@/api";
import corporateWelfareTree from "@/shared/utils/trees";
import moment from "moment";
export default {
  beforeRouteEnter(to, from, next) {
    console.log(from);
    if (from.path === "/post-service") {
      next();
    } else {
      next((vm) => {
        vm.form.resetFields();
      });
    }
  },
  name: "Create",
  components: {
    DividerBar,
  },
  data() {
    return {
      moment,
      recruitment_deadline: -1,
      work_time_type: -1,
      work_date_type: -1,
      form: this.$form.createForm(this, { name: "formOnly" }),
      job_attribute: "2",
      magellan_company_user_id: 0,
      originCompanyData: [],
      dataCompanyNameList: [],
      functionId: [],
      cityOptions: undefined,
      companyWelfareTree: corporateWelfareTree,
      workExperienceData: [
        { label: "不限", value: "0" },
        { label: "1年以下", value: "1" },
        { label: "1-3年", value: "2" },
        { label: "3-5年", value: "3" },
        { label: "5-10年", value: "4" },
        { label: "10-15年", value: "5" },
        { label: "15年以上", value: "6" },
      ],
      educationData: [
        { label: "不限", value: "0" },
        { label: "博士", value: "1" },
        { label: "MBA/EMBA", value: "2" },
        { label: "硕士", value: "3" },
        { label: "本科", value: "4" },
        { label: "大专", value: "5" },
        { label: "高中/中专", value: "6" },
      ],
      settlementData: [
        { label: "日结", value: 1 },
        { label: "周结", value: 2 },
        { label: "月结", value: 3 },
        { label: "完工结", value: 4 },
      ],

      taskWorkEmployTypeData: [
        { label: "短期雇佣", value: 2 },
        { label: "长期雇佣", value: 1 },
        { label: "1次性任务", value: 3 },
      ],
      taskWorkTimeTypeData: [
        { label: "分钟", value: 1 },
        { label: "小时", value: 2 },
        { label: "天", value: 3 },
      ],
      contactTypeData: [
        { label: "微信", value: 1 },
        { label: "微信公众号", value: 2 },
        { label: "电话联系", value: 3 },
        { label: "QQ", value: 4 },
        { label: "QQ群", value: 5 },
        { label: "不要主动联系我", value: 6 },
      ],
      bonus_type: 0,
      postsite_type: 0,
      height_requirements: 0,
      contact_type: 0,
      addressData: [],
      selectCityName: "",
      location: "",
      /**
       * 灵工任务
       *
       */
      task_step_content_id: 0,
      keysList: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
      },
      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 },
        },
      },
    };
  },
  activated() {},
  mounted() {
    this.job_attribute = this.$route.query.job_attribute;
  },
  methods: {
    changeDeadline() {},
    selectLocation(value, options) {
      this.location = JSON.stringify(options.data.attrs.location);
    },
    handleSelectCity(value, selectedOptions) {
      this.selectCityName =
        selectedOptions && selectedOptions[1] && selectedOptions[1].name;
    },
    async onSearchAddress(keywords) {
      let res = await Api.common.searchAddress({
        keywords,
        city_name: this.selectCityName,
      });
      console.log(res);
      this.addressData = res.list;
    },
    changeJobAttribute(e) {
      this.job_attribute = e.target.value;
    },
    async getOptions() {
      // this.cityOptions = undefined;
      let { tree } = await Api.common.getCityTree();
      this.cityOptions = tree;
    },
    async initFuncData() {
      let response;
      try {
        response = await Api.common.getPostTree();
        console.log(response);
        this.functionId = [...response.tree];
      } catch (e) {
        e.message.cached && (response = e.message.data);
      }
    },
    onSearchCompany(value) {
      if (!value) return false;
      Api.post
        .getCompanyInfo({
          company_name: value,
          audit_status: 2,
          is_sign: 1,
          is_acting: 1,
        })
        .then((res) => {
          const data = [];
          this.originCompanyData = res;
          res.forEach((item) => {
            data.push({
              text: item.name,
              value: item.id,
            });
          });
          this.dataCompanyNameList = data;
        });
    },
    selectComId(val) {
      let filter = this.originCompanyData.filter((x) => {
        return x.id === val;
      });
      this.magellan_company_user_id = filter[0].magellan_company_user_id;
    },
    handleSubmit(e) {
      e.preventDefault();
      let that = this;
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          if (this.job_attribute === "3") {
            values.flexible_job.height_requirements =
              (values.flexible_job &&
                values.flexible_job.height_requirements_value) ||
              values.flexible_job.height_requirements;
            values.flexible_job.work_date_start_at =
              values.flexible_job.work_date_value &&
              moment(values.flexible_job.work_date_value[0]);
            values.flexible_job.work_date_end_at =
              values.flexible_job.work_date_value &&
              moment(values.flexible_job.work_date_value[1]);
            values.flexible_job.work_time_start_at = values.flexible_job
              .work_time_start_at
              ? moment(values.flexible_job.work_time_start_at).format("HH:mm")
              : "09:00";
            values.flexible_job.work_time_end_at = values.flexible_job
              .work_time_end_at
              ? moment(values.flexible_job.work_time_end_at).format("HH:mm")
              : "09:00";
            values.flexible_job.recruitment_deadline =
              values.flexible_job.recruitment_deadline &&
              moment(values.flexible_job.recruitment_deadline).format(
                "YYYY-MM-DD"
              );
          }
          values.address = values.location;
          let params = {
            ...values,
            task_step_content: JSON.stringify(values.task_step_content),
            location: this.location,
            magellan_company_user_id: this.magellan_company_user_id,
            selling_point_tags: JSON.stringify(values.selling_point_tags),
            job_areas: JSON.stringify([
              {
                province_id: values.city && values.city[0],
                city_id: values.city && values.city[1],
                dist_id: values.city && values.city[2],
              },
            ]),
            first_category_id: values.category_id && values.category_id[0],
            second_category_id: values.category_id && values.category_id[1],
            third_category_id: values.category_id && values.category_id[2],
          };
          delete params.city;
          delete params.category_id;
          sessionStorage.setItem("create_form", JSON.stringify(params));
          let query = {
            job_attribute: that.job_attribute,
            task_step_content: values.task_step_content,
          };
          if (that.job_attribute === "3" || that.job_attribute === "4") {
            query.basic_salary = values.flexible_job.basic_salary;
            query.basic_salary_period = values.flexible_job.basic_salary_period;
          }
          console.log(values, "正确");

          this.$router.push({
            path: "/post-service",
            query: query,
          });
          // Api.post.createPost(params).then((res) => {
          //   if (res && res.job_id) {
          //     that.$message.success("提交成功");
          //     let query = {
          //       job_id: res.job_id,
          //       job_attribute: that.job_attribute,
          //     };
          //     if (that.job_attribute === "3") {
          //       query.basic_salary = values.flexible_job.basic_salary;
          //       query.basic_salary_period =
          //         values.flexible_job.basic_salary_period;
          //     }
          //     that.$router.push({
          //       path: "/post-service",
          //       query: query,
          //     });
          //   }
          // });
        } else {
          console.log(err, "报错");
          console.log('job_attribute',this.job_attribute)
          console.log(values, 1123123);
          // let query = {
          //   job_attribute: that.job_attribute,
          //   task_step_content: values.task_step_content,
          // };
          // if (that.job_attribute === "3" || that.job_attribute === "4") {
          //   query.basic_salary = values.flexible_job.basic_salary;
          //   query.basic_salary_period = values.flexible_job.basic_salary_period;
          // }
          // // test
          // this.$router.push({
          //   path: "/post-service",
          //   query: query,
          // });
        }
      });
    },
    /**
     * 灵工任务流程
     */
    remove(k) {
      if (this.keysList.length === 1) {
        // 如果存在可以移除所有行的情况，把条件改为this.keysList.length === 0即可
        return;
      }
      this.keysList = this.keysList.filter((item) => item !== k);
    },

    addRow() {
      this.task_step_content_id = this.task_step_content_id + 1;
      this.keysList = this.keysList.concat(this.task_step_content_id);
    },

    /**
     * 发布任务
     */
    postMoneyTask() {
      this.$router.push({
        path: "/post-money-task",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.create {
  .header-timeline {
    margin: 50px auto;
    width: 45%;
  }

  .content {
    margin: 0 auto;
    width: 70%;
    .radio-tip {
      font-size: 12px;
      color: #999;
      margin-top: 3px;
    }
  }
  .dynamic-delete-button {
    cursor: pointer;
    position: relative;
    top: 4px;
    font-size: 24px;
    color: #999;
    transition: all 0.3s;
  }
  .dynamic-delete-button:hover {
    color: #777;
  }
  .dynamic-delete-button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
